(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-section="collection-tabs"] .new_filter a[data-tab]');
  if (!tab) return;

  var section = tab.closest('[data-section="collection-tabs"]');
  var panelId = tab.getAttribute('data-tab');
  var panel = section.querySelector('#' + panelId);
  if (!panel) return;

  event.preventDefault();

  section.querySelectorAll('.new_filter li').forEach(function (item) {
    item.classList.remove('active');
  });
  section.querySelectorAll('.new_filter a[data-tab]').forEach(function (item) {
    item.setAttribute('aria-selected', 'false');
  });
  section.querySelectorAll('.tab-contents').forEach(function (item) {
    item.classList.remove('active');
  });

  tab.closest('li').classList.add('active');
  tab.setAttribute('aria-selected', 'true');
  panel.classList.add('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab20-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const checkSales = () => {
      document.querySelectorAll('[data-tsl-sale-expiry]').forEach(element => {
        const expiry = Date.parse(element.dataset.tslSaleExpiry);
        if (!Number.isFinite(expiry) || Date.now() <= expiry) return;
        if (element.dataset.tslSaleFallbackImage) {
          const image = element.querySelector('img');
          if (image) {
            image.removeAttribute('srcset');
            image.src = element.dataset.tslSaleFallbackImage;
            image.alt = element.dataset.tslSaleFallbackAlt || '';
          }
          element.querySelectorAll('picture source').forEach(source => {
            if (element.dataset.tslSaleFallbackDesktopImage) {
              source.srcset = element.dataset.tslSaleFallbackDesktopImage;
              source.width = 2560;
              source.height = 1024;
            } else {
              source.remove();
            }
          });
          element.href = element.dataset.tslSaleFallbackLink;
          element.removeAttribute('data-tsl-sale-expiry');
        } else {
          element.hidden = true;
        }
      });
    };
    checkSales();
    document.addEventListener('DOMContentLoaded', checkSales, {once:true});
    document.addEventListener('shopify:section:load', checkSales);
    document.addEventListener('visibilitychange', checkSales);
    setInterval(checkSales, 15000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-image-and-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMedia = (root) => {
      if (root.dataset.homeGryMediaReady === 'true') return;

      const video = root.querySelector('[data-desktop-video]');
      if (!video) return;

      root.dataset.homeGryMediaReady = 'true';

      const desktop = window.matchMedia('(min-width: 769px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sources = Array.from(video.querySelectorAll('source[data-src]'));

      const detachSources = () => {
        video.pause();

        sources.forEach((source) => {
          if (!source.src) return;
          source.dataset.src = source.src;
          source.removeAttribute('src');
        });

        video.load();
      };

      const attachSources = () => {
        let changed = false;

        sources.forEach((source) => {
          if (source.src || !source.dataset.src) return;
          source.src = source.dataset.src;
          changed = true;
        });

        if (changed) video.load();
      };

      const synchronize = () => {
        if (!desktop.matches) {
          detachSources();
          return;
        }

        attachSources();

        if (reducedMotion.matches) {
          video.pause();
          return;
        }

        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      desktop.addEventListener('change', synchronize);
      reducedMotion.addEventListener('change', synchronize);
      synchronize();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-home-gry-media]').forEach(initializeMedia);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-slider"] && !Shopify.designMode) return;
  try {
    
  function connectStudioCarousel(root, attempt = 0) {
    if (!root || root.dataset.connected) return;
    const viewport = root.querySelector('.swiper-container');
    const swiper = viewport.swiper;
    if (!swiper) {
      if (attempt < 100) setTimeout(() => connectStudioCarousel(root, attempt + 1), 100);
      return;
    }
    root.dataset.connected = 'true';
    const count = root.querySelector('.studio-carousel__count');
    const slides = [...root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')];
    const update = () => {
      count.textContent = `${swiper.realIndex + 1} / ${slides.length}`;
      [...viewport.querySelectorAll('.swiper-slide')].forEach(slide => {
        const active = slide.classList.contains('swiper-slide-active');
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
    };
    const pause = () => {
      swiper.autoplay.stop();
      root.querySelector('.tsl-carousel-pause').setAttribute('aria-pressed', 'true');
    };
    root.querySelector('.studio-carousel__previous').addEventListener('click', () => { pause(); swiper.slidePrev(); });
    root.querySelector('.studio-carousel__next').addEventListener('click', () => { pause(); swiper.slideNext(); });
    root.querySelector('.swiper-pagination').addEventListener('click', pause);
    root.addEventListener('focusin', event => {
      if (event.target.closest('.tsl-carousel-pause')) return;
      swiper.autoplay.stop();
      root.querySelector('.tsl-carousel-pause').setAttribute('aria-pressed', 'true');
    });
    root.addEventListener('pointerenter', () => swiper.autoplay.stop());
    root.addEventListener('pointerleave', () => {
      if (root.querySelector('.tsl-carousel-pause').getAttribute('aria-pressed') !== 'true' && !root.contains(document.activeElement)) swiper.autoplay.start();
    });
    swiper.on('slideChangeTransitionStart', update);
    swiper.on('slideChangeTransitionEnd', update);
    update();
    if (window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) {
      swiper.autoplay.stop();
      root.querySelector('.tsl-carousel-pause').setAttribute('aria-pressed', 'true');
    }
  }
  const connectStudioCarousels = () => document.querySelectorAll('[data-studio-carousel]').forEach(root => connectStudioCarousel(root));
  document.addEventListener('DOMContentLoaded', connectStudioCarousels);
  window.addEventListener('load', connectStudioCarousels);
  if (document.readyState !== 'loading') connectStudioCarousels();
  document.addEventListener('click', event => {
    const button = event.target.closest('.tsl-carousel-pause');
    if (!button) return;
    const swiper = button.closest('.swiper-container').swiper;
    if (!swiper || !swiper.autoplay) return;
    const paused = button.getAttribute('aria-pressed') === 'true';
    if (paused) swiper.autoplay.start(); else swiper.autoplay.stop();
    button.setAttribute('aria-pressed', String(!paused));
  });
  const respectCarouselMotion = () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.home-banner--campaign-art .swiper-container').forEach(container => {
      if (!container.swiper || !container.swiper.autoplay) return;
      container.swiper.autoplay.stop();
      container.querySelector('.tsl-carousel-pause').setAttribute('aria-pressed', 'true');
    });
  };
  document.addEventListener('DOMContentLoaded', respectCarouselMotion);
  window.addEventListener('load', respectCarouselMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsl-studio-header"]) return;
  try {
    
  function wireStudioHeader(root) {
    if (!root || root.dataset.wired) return;
    root.dataset.wired = 'true';
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const opened = event.target.closest('details[open]');
      if (opened) {
        opened.open = false;
        opened.querySelector('summary').focus();
        event.stopPropagation();
      }
    });
    root.querySelectorAll('.studio-nav-details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        details.parentElement.querySelectorAll('.studio-nav-details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (root.contains(event.target)) return;
      root.querySelectorAll('details[open]').forEach((item) => { item.open = false; });
    });
  }
  document.querySelectorAll('[data-studio-header]').forEach(wireStudioHeader);
  document.addEventListener('shopify:section:load', (event) => wireStudioHeader(event.target.querySelector('[data-studio-header]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsl-studio-home"] && !Shopify.designMode) return;
  try {
    
  function initializeStudioExplorer(root) {
    root.querySelectorAll('[data-studio-home]').forEach(home => {
      if (home.classList.contains('studio-home--culture')) return;
      const tablist = home.querySelector('.studio-family-switcher');
      if (!tablist || tablist.dataset.ready) return;
      const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      if (!tabs.length || panels.some(panel => !panel)) return;
      function select(index, focus = false) {
        tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[position].hidden = !active;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          const moves = {ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1};
          if (!(event.key in moves)) return;
          event.preventDefault();
          select(moves[event.key], true);
        });
      });
      select(0);
      tablist.hidden = false;
      tablist.dataset.ready = 'true';
      home.classList.add('studio-home--interactive');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeStudioExplorer(document));
  else initializeStudioExplorer(document);
  document.addEventListener('shopify:section:load', event => initializeStudioExplorer(event.target));

  } catch(e) { console.error(e); }
})();
})();
